import { gql } from '@apollo/client'

const SEARCH_COHORTS = gql`
  query SearchCohorts(
    $id: Int
    $name: String
    $funderName: String
    $nonprofitName: String
    $limit: Int
    $offset: Int
  ) {
    searchCohorts(
      id: $id
      name: $name
      funderName: $funderName
      nonprofitName: $nonprofitName
      limit: $limit
      offset: $offset
    ) {
      total
      cohorts {
        id
        name
        startDate
        endDate
        createdAt
        updatedAt
        memberRoles
        cohortOwnerships {
          id
          funderOrg {
            id
            name
          }
        }
        cohortMemberships {
          id
          startDate
          endDate
          nonprofitOrg {
            id
            name
          }
        }
      }
    }
  }
`

export default SEARCH_COHORTS
